import { ChangeEvent, FC, useCallback, useState } from 'react';

import { startOfMonth } from 'date-fns';
import { formatDate } from 'utils/date';

import { Button, Text, TextArea, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import { downloadSegmentsReport } from 'components/Admin/YandexDirectReport/SegmentsReport/downloadSegmentsReport';

import { useDispatch } from 'store/utils';

const TrlKeys = {
    title: 'admin.directReport.segments.title',
    loginsPlaceholder: 'admin.directReport.segments.logins.placeholder',
    download: 'admin.directReport.segments.download',
};

export const SegmentsReport: FC = () => {
    const [logins, setLogins] = useState('');
    const [dateFrom, setDateFrom] = useState(() => startOfMonth(new Date()));
    const [dateTo, setDateTo] = useState(() => new Date());
    const [isDownloading, setIsDownloading] = useState(false);

    const trl = useTrls();
    const dispatch = useDispatch();

    const handleLoginsChange = (event: ChangeEvent<HTMLTextAreaElement>) => setLogins(event.target.value);

    const handleDatesChange = useCallback((from: Date, to: Date) => {
        setDateFrom(from);
        setDateTo(to);
    }, []);

    const handleDownload = async () => {
        setIsDownloading(true);
        try {
            await dispatch(
                downloadSegmentsReport({ logins, dateFrom: formatDate(dateFrom), dateTo: formatDate(dateTo) })
            );
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <>
            <Text typography="title-4-semibold">{trl(TrlKeys.title)}</Text>
            <VSpacing default={24} />
            <TextArea
                value={logins}
                onChange={handleLoginsChange}
                name="logins"
                layout="hug"
                placeholder={trl(TrlKeys.loginsPlaceholder)}
            />
            <VSpacing default={16} />
            <InputWithMultiDatePicker from={dateFrom} to={dateTo} action={handleDatesChange} closeAfterSelect />
            <VSpacing default={24} />
            <Button
                mode="secondary"
                style="accent"
                size="large"
                onClick={handleDownload}
                loading={isDownloading}
                disabled={!logins.trim()}
            >
                {trl(TrlKeys.download)}
            </Button>
        </>
    );
};
